export class GlossaryTerm {
  id: number;
  createdBy: string;
  term: string;
  definition: string;
  type: string;
  extendedDefinition: string;
}
